import React, { useEffect, useState } from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import axios from "axios";
import { BaseUrl } from "../../helper/apiHelper";
import toast from "react-hot-toast";

const WeQa = () => {
  const [qaEnquiry, setQaInquiry] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [showMessageModal, setShowMessageModal] = useState(false);
    const [messageContent, setMessageContent] = useState("");
  const itemsPerPage = 10;

  const getWeQaInquiryMasterAdmin = async () => {
    setLoading(true);
    try {
      let response = await axios.get(`${BaseUrl}/get-we-qa-enquiry`);

      if (response.status === 200) {
        setQaInquiry(response.data.data);
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setCurrentPage(1);
    getWeQaInquiryMasterAdmin();
  }, []);

  const paginatedInquiry = qaEnquiry?.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );
  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = date.toLocaleString("default", { month: "long" });
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }
  return (
    <MasterLayout>
      <Breadcrumb title="WeQa" />

      <div className="col-lg-12">
        <div className="card">
          <div className="card-header py-16 pb-0 px-24 bg-base border border-end-0 border-start-0 border-top-0 d-flex align-items-center flex-wrap justify-content-between">
            <h6 className="text-lg mb-0">WeQa</h6>
          </div>

          <div className="card-body">
            {loading ? (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{
                  minHeight: "calc(100vh - 300px)",
                  width: "100%",
                  background: "transparent",
                }}
              >
                <div
                  className="spinner-border"
                  role="status"
                  style={{
                    color: "#243E85",
                    width: "3rem",
                    height: "3rem",
                  }}
                >
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : paginatedInquiry.length === 0 ? (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{
                  minHeight: "200px",
                  width: "100%",
                  fontSize: "1.2rem",
                  color: "#243E85",
                  fontWeight: 500,
                }}
              >
                No inquiries found.
              </div>
            ) : (
              <>
                <div className="table-responsive">
                  <table className="table basic-border-table mb-0">
                    <thead>
                      <tr>
                        <th>Date</th>
                        <th>FullName</th>
                        <th>Email</th>
                        <th>Mobile Number</th>
                        <th>Message</th>
                      </tr>
                    </thead>
                    <tbody>
                      {paginatedInquiry?.map((items, index) => (
                        <tr key={index}>
                          <td>{formatDate(items?.createdAt)}</td>
                          <td>{items?.fullname}</td>
                          <td>{items?.email}</td>
                          <td>
                            {items.mobile_number
                              ? items.country_code + " " + items.mobile_number
                              : ""}
                          </td>

                          <td>
                            <button
                              className="btn btn-link  p-0"
                              style={{ color: "#243E85" }}
                              onClick={() => {
                                setMessageContent(items?.additional_info || "");
                                setShowMessageModal(true);
                              }}
                            >
                              View Message
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                {/* Pagination controls */}
                {qaEnquiry?.length > itemsPerPage && (
                  <div className="mt-4 d-flex justify-content-between align-items-center">
                    <span>
                      Showing {(currentPage - 1) * itemsPerPage + 1} to{" "}
                      {Math.min(currentPage * itemsPerPage, qaEnquiry.length)}{" "}
                      of {qaEnquiry.length} Inquiry
                    </span>
                    <div className="d-flex gap-2">
                      <button
                        className="btn btn-sm btn-outline-primary"
                        onClick={() =>
                          setCurrentPage((prev) => Math.max(prev - 1, 1))
                        }
                        disabled={currentPage === 1}
                      >
                        Prev
                      </button>
                      <button
                        className="btn btn-sm btn-outline-primary"
                        onClick={() =>
                          setCurrentPage((prev) =>
                            prev < Math.ceil(qaEnquiry.length / itemsPerPage)
                              ? prev + 1
                              : prev
                          )
                        }
                        disabled={
                          currentPage ===
                          Math.ceil(qaEnquiry.length / itemsPerPage)
                        }
                      >
                        Next
                      </button>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
      {showMessageModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1050,
          }}
        >
          <div className="card" style={{ width: "90%", maxWidth: 490 }}>
            <div className="card-header d-flex justify-content-between align-items-center">
              <h6 className="mb-0">Message</h6>
              <button
                className="btn btn-sm btn-outline-secondary"
                onClick={() => setShowMessageModal(false)}
              >
                Close
              </button>
            </div>
            <div className="card-body">
              {messageContent ? (
                <p style={{ whiteSpace: "pre-wrap" }}>{messageContent}</p>
              ) : (
                <p className="text-muted">No message provided</p>
              )}
            </div>
          </div>
        </div>
      )}
    </MasterLayout>
  );
};

export default WeQa;
